import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledState as $bOkae$useControlledState } from "@react-stately/utils";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $3017fa7ffdddec74$exports = {};
$parcel$export($3017fa7ffdddec74$exports, "useToggleState", function () {
  return $3017fa7ffdddec74$export$8042c6c013fd5226;
});

function $3017fa7ffdddec74$export$8042c6c013fd5226() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isReadOnly = props.isReadOnly; // have to provide an empty function so useControlledState doesn't throw a fit
  // can't use useControlledState's prop calling because we need the event object from the change

  var _$bOkae$useControlled = $bOkae$useControlledState(props.isSelected, props.defaultSelected || false, props.onChange),
      _$bOkae$useControlled2 = _slicedToArray(_$bOkae$useControlled, 2),
      isSelected = _$bOkae$useControlled2[0],
      setSelected = _$bOkae$useControlled2[1];

  function updateSelected(value) {
    if (!isReadOnly) setSelected(value);
  }

  function toggleState() {
    if (!isReadOnly) setSelected(!isSelected);
  }

  return {
    isSelected: isSelected,
    setSelected: updateSelected,
    toggle: toggleState
  };
}

export { $3017fa7ffdddec74$export$8042c6c013fd5226 as useToggleState };